import { CurrentUserDto } from '../../../../types/UserDtos';
import { getCurrentUser } from '../../services/CurrentUser';
import { isFeatureAvailable, isFeatureEnabled, isFeatureEnabledForUser } from '../../services/Features';
import { hasBasicHr } from '../../services/User';

export type AiCoachLimits = {
    maxCoaches: number | 'UNLIMITED';
    maxResources: number | 'UNLIMITED';
};

export function isAiCoachAvailable(): boolean {
    return isFeatureAvailable('FEATURE_aiCoach') || isFeatureAvailable('FEATURE_aiCoachUnlimited');
}

const AI_COACH_CONTEXT_FEATURE = {
    clippy: 'FEATURE_aiCoachClippy',
    workspace: 'FEATURE_aiCoachWorkspace',
} as const;

type Context = keyof typeof AI_COACH_CONTEXT_FEATURE;

export function shouldShowAiCoach(context: Context): boolean {
    const user = getCurrentUser();
    const userCanPreview = hasBasicHr(user) || user.isSmallImprovements;

    const coachForAllUsers = isFeatureEnabled('FEATURE_aiCoach');
    const flagEnabledForContext = isFeatureEnabled(AI_COACH_CONTEXT_FEATURE[context]);
    const aiEnabledGlobally = isFeatureEnabled('ai-features');

    return aiEnabledGlobally && (userCanPreview || (coachForAllUsers && flagEnabledForContext));
}

export function shouldDisplayAdminOnlyInformation(context: Context, user: CurrentUserDto): boolean {
    const userIsHr = hasBasicHr(user);
    const coachForAllUsers = isFeatureEnabledForUser('FEATURE_aiCoach', user);
    const flagEnabledForContext = isFeatureEnabledForUser(AI_COACH_CONTEXT_FEATURE[context], user);

    return !(coachForAllUsers && flagEnabledForContext) && userIsHr;
}

export function getAiCoachLimits(): AiCoachLimits {
    const currentCompanySettings = getCurrentUser().company.companySettings;

    if (isFeatureAvailable('FEATURE_aiCoachUnlimited')) {
        return { maxCoaches: 'UNLIMITED', maxResources: 'UNLIMITED' };
    } else {
        return { maxCoaches: currentCompanySettings.maxAiCoaches, maxResources: currentCompanySettings.maxAiResources };
    }
}
